// src/components/elements/SettingsForm.js
import React, { useState, useEffect } from 'react';
import useUserStore from '../../contexts/useUserStore';

const SettingsForm = () => {
  const { baseLocation, setBaseLocation, status, setStatus } = useUserStore();
  const [locations, setLocations] = useState([{ name: '', coords: [0, 0] }]);
  const [statuses, setStatuses] = useState([{ name: '', paid: '' }]);

  useEffect(() => {
    // Load dropdown data from JSON files in the public directory
    fetch('/local_data/baseLocations.json')
      .then((res) => res.json())
      .then(setLocations);

    fetch('/local_data/statusOptions.json')
      .then((res) => res.json())
      .then(setStatuses);
  }, []);

  return (
    <div>
      {/* Base Location Dropdown */}
      <div className="flex items-center mb-4 text-gray-500">
        <label htmlFor="baseLocation" className="text-sm font-medium w-1/3">
          Base Location
        </label>
        <select
          id="baseLocation"
          value={baseLocation?.name || ""}
          onChange={(e) => {
            const selectedLocation =
              locations.find((location) => location.name === e.target.value) ||
              baseLocation ||
              { name: "", coords: [0, 0] };
            setBaseLocation(selectedLocation);
          }}
          className="mt-1 block w-2/3 p-2 border border-gray-300 rounded-md"
        >
          <option value="">Select a location</option>
          {locations.map((location) => (
            <option key={location.name} value={location.name}>
              {location.name} (Lat: {location.coords[0]}, Long: {location.coords[1]})
            </option>
          ))}
        </select>
      </div>

      {/* Status Dropdown */}
      <div className="flex items-center mb-4 text-gray-500">
        <label htmlFor="status" className="text-sm font-medium w-1/3">
          Status
        </label>
        <select
          id="status"
          value={status || ""}
          onChange={(e) => setStatus(e.target.value)}
          className="mt-1 block w-2/3 p-2 border border-gray-300 rounded-md"
        >
          <option value="">Switch membership</option>
          {statuses.map((stat) => (
            <option key={stat.name} value={stat.name}>
              {stat.name} (Paid: {stat.paid})
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default SettingsForm;
